module.exports = function isNil(x) {
  return x === null || x === void 0;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/isNil.js
 ** module id = 25
 ** module chunks = 0
 **/